import { baseURL } from '../Config';
import axios from 'axios';
import { toast } from 'react-toastify';

export const handleGetRequest = async (url, isShowToast = false, responseCode = '') => {
    try {
        const response = await axios.get(`${baseURL + url}`, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        });
        if (isShowToast) {
            if (response?.data?.success) {
                toast.success(response?.data?.message || 'Request successful');
            } else {
                toast.error(response?.data?.message || 'Request failed');
            }
        }
        return response.data;
    } catch (error) {
        const id = toast.loading('Please wait...');
        if (error?.response?.status === 500) {
            setTimeout(() => {
                toast.update(id, {
                    render: error?.response?.data?.message || error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong !!',
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000
                });
            }, 100);
        } else if (error?.response?.status === 401) {
            setTimeout(() => {
                toast.update(id, {
                    render: 'Session expired, please login again',
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000
                });
            }, 100);
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = '/';
        } else {
            setTimeout(() => {
                toast.update(id, {
                    render: error?.response?.data?.message || error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong !!',
                    type: 'warn',
                    isLoading: false,
                    autoClose: 3000
                });
            }, 100);
        }
    }
};
